import script from "./AdminUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUpload.vue?vue&type=script&setup=true&lang=js"

import "./AdminUpload.vue?vue&type=style&index=0&id=6bbdc9eb&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bbdc9eb"]])

export default __exports__